<template>
  <v-flex xs12>
    <h5>Stripe Payment Details</h5>
    <v-layout v-if="paymentIntent">
      <v-flex class="py-0 px-0">
        <v-list
          class="py-0 px-0"
          dense
        >
          <v-list-item
            class="py-0 px-0 list-item-height"
            dense
          >
            <v-list-item-content>
              <v-list-item-subtitle>
                <span class="text--primary">{{formatDate(paymentIntent.created)}}</span> <v-chip
                  x-small
                  :color="getPaymentIntentStatusColor(paymentIntent.status)"
                >
                {{ paymentIntent.status }}
                </v-chip>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            class="py-0 px-0 list-item-height"
            dense
          >
            <v-list-item-content>
              <v-list-item-subtitle>
                <span class="text--primary">Paid By</span> Stripe
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            class="py-0 px-0 list-item-height"
            dense
          >
            <v-list-item-content>
              <v-list-item-subtitle>
                <span class="text--primary">Transaction ID</span> {{paymentIntent.id}}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            class="py-0 px-0 list-item-height"
            dense
          >
            <v-list-item-content>
              <v-list-item-subtitle>
                <span class="text--primary">Statement Description</span> {{paymentIntent.statement_descriptor}}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            class="py-0 px-0 list-item-height"
            dense
          >
            <v-list-item-content>
              <v-list-item-subtitle>
                <span class="text--primary">Amount</span> £{{formatAmount(paymentIntent.amount)}}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            class="py-0 px-0 list-item-height"
            dense
          >
            <v-list-item-content>
              <v-list-item-subtitle>
                <span class="text--primary">Fee</span> £{{formatAmount(totalFee)}}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            class="py-0 px-0 list-item-height"
            dense
          >
            <v-list-item-content>
              <v-list-item-subtitle>
                <span class="text--primary">Net</span> £{{formatAmount(netAmount)}}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-flex>
    </v-layout>
    <v-row
      wrap
      align-start
    >
      <v-btn
        small
        class="text-none"
        target="_blank"
        :href="cardPaymentLink"
      >
        View on Stripe: {{bookingForm.booking.card_status}}
      </v-btn>
      <v-btn
        small
        class="text-none"
        target="_blank"
        v-if="loadingCapture == false && (bookingForm.booking.card_status != 'completed')"
        @click="captureImmediatePayment"
      >
        Capture Immediate Payment
      </v-btn>
      <v-progress-circular
        v-if="loadingCapture == true"
        :size="25"
        :width="2"
        color="blue"
        indeterminate
      ></v-progress-circular>
      <v-flex>
        <StripeRefund :booking-form="bookingForm" />
      </v-flex>
      <v-flex pt-4>
        <p
          v-if="bookingForm.booking.refunded == true"
          style="padding-top: 12px !important; font-size: 12px;"
        >
          Booking has already been fully/partially refunded
        </p>
      </v-flex>
      <p
        v-if="hasOutboundAndReturn"
        v-html="outboundAndReturnString"
      />
    </v-row>
  </v-flex>
</template>

<script>
import StripeRefund from "@/components/booking/StripeRefund.vue";

import axios from "axios";
import moment from 'moment'

axios.defaults.withCredentials = true;

export default {
  name: "StripeTransactionDetailsV2",
  components: {
    StripeRefund,
  },
  props: {
    bookingForm: Object,
  },
  data: function () {
    return {
      dialog: false,
      loading: false,
      transactions: [],
      loadingCapture: false,
    };
  },
  computed: {
    totalFee () {
      let fee = 0;
      this.paymentIntent.charges.data.forEach(charge => {
        if (charge.balance_transaction) {
          fee += charge.balance_transaction.fee
        }
      })
      return fee
    },
    netAmount () {
        return (this.paymentIntent.amount - this.totalFee)
    },
    paymentIntent () {
      if (this.bookingForm.booking.payment_intent) {
        return JSON.parse(this.bookingForm.booking.payment_intent)
      }
      return null;
    },
    hasOutboundAndReturn: function() {
      return (this.bookingForm.booking.cart != null && this.bookingForm.booking.cart.outboundBookingId != null && this.bookingForm.booking.cart.returnBookingId != null);
    },
    outboundAndReturnString: function() {
      if (this.bookingForm.booking.cart != null && this.bookingForm.booking.cart.outboundBookingId != null && this.bookingForm.booking.cart.returnBookingId != null) {
        return "This stripe payment is associated with two bookings.<br><b>Outbound:</b> " + this.bookingForm.booking.cart.outboundBookingId + "<br><b>Return:</b> " + this.bookingForm.booking.cart.returnBookingId;
      } 

      return "";
    },
    cardPaymentLink: function () {
      return (
        "https://dashboard.stripe.com/search?query=" +
        ((this.bookingForm.booking.card_payment_type == null || this.bookingForm.booking.card_payment_type != 'prepaid')
          ? this.bookingForm.booking.id
          : this.bookingForm.booking.cart.cartId)
      );
    },
    transactionTable: function () {
      if (this.transactions != null && this.transactions.length > 0) {
        var table = "";

        for (var i = 0; i < this.transactions.length; i++) {
          var transaction = this.transactions[i];

          var tr = "<tr>";

          var date = new Date(transaction["created"] * 1000);

          var td =
            '<td style="border: 1px solid black; padding: 10px;">' +
            date.getDate() +
            "/" +
            (date.getMonth() + 1) +
            "/" +
            date.getFullYear() +
            " " +
            date.getHours() +
            ":" +
            date.getMinutes() +
            ":" +
            date.getSeconds() +
            "</td>";

          tr += td;

          td =
            '<td style="border: 1px solid black; padding: 10px;">' +
            transaction["description"] +
            "</td>";

          tr += td;

          if (transaction["captured"] == true) {
            td =
              '<td style="border: 1px solid black; padding: 10px;">Captured</td>';
            tr += td;
          } else if (transaction["refunded"] == true) {
            td =
              '<td style="border: 1px solid black; padding: 10px;">Refunded</td>';
            tr += td;
          } else if (transaction["status"] == "failed") {
            td =
              '<td style="border: 1px solid black; padding: 10px;">Failed: ' +
              transaction["failure_message"] +
              "</td>";
            tr += td;
          } else {
            td =
              '<td style="border: 1px solid black; padding: 10px;">Pre-auth</td>';
            tr += td;
          }

          if (transaction["refunded"] == true) {
            if (
              transaction["refunds"] != null &&
              transaction["refunds"]["data"] != null &&
              transaction["refunds"]["data"][0] != null &&
              transaction["refunds"]["data"][0]["metadata"] != null &&
              transaction["refunds"]["data"][0]["metadata"]["reason"] != null
            ) {
              td =
                '<td style="border: 1px solid black; padding: 10px;"><b>Refunded</b>: £' +
                (transaction["amount"] / 100).toFixed(2) +
                " <br/> Reason: " +
                transaction["refunds"]["data"][0]["metadata"]["reason"] +
                " </td>";
            } else {
              td =
                '<td style="border: 1px solid black; padding: 10px;"><b>Refunded</b>: £' +
                (transaction["amount"] / 100).toFixed(2) +
                "</td>";
            }
            tr += td;
          } else if (transaction["captured"] == true) {
            if (transaction["amount_refunded"] == 0) {
              td =
                '<td style="border: 1px solid black; padding: 10px;"><b>Final charge</b>: £' +
                (transaction["amount"] / 100).toFixed(2) +
                "</td>";
              tr += td;
            } else {
              td =
                '<td style="border: 1px solid black; padding: 10px;"><b>Pre-auth</b>: £' +
                (transaction["amount"] / 100).toFixed(2) +
                "<br/><b>Refunded</b>: £" +
                (transaction["amount_refunded"] / 100).toFixed(2) +
                "<br/><b>Final charge</b>: £" +
                (
                  (transaction["amount"] - transaction["amount_refunded"]) /
                  100
                ).toFixed(2) +
                "</td>";
              tr += td;
            }
          } else if (transaction["status"] == "failed") {
            td =
              '<td style="border: 1px solid black; padding: 10px;"><b>Failed</b></td>';
            tr += td;
          } else {
            td =
              '<td style="border: 1px solid black; padding: 10px;"><b>Pre-auth</b>: £' +
              (transaction["amount"] / 100).toFixed(2) +
              "</td>";
            tr += td;
          }

          if (
            transaction["charges"]["data"][0]["payment_method_details"][
              "card"
            ] != null
          ) {
            td =
              '<td style="border: 1px solid black; padding: 10px;">' +
              transaction["charges"]["data"][0]["payment_method_details"][
                "card"
              ]["brand"] +
              " " +
              transaction["charges"]["data"][0]["payment_method_details"][
                "card"
              ]["last4"] +
              "</td>";
            tr += td;
          } else {
            td =
              '<td style="border: 1px solid black; padding: 10px;">' +
              transaction["source"]["type_data"]["brand"] +
              " " +
              transaction["source"]["type_data"]["last4"] +
              "</td>";
            tr += td;
          }

          tr += "</tr>";

          table += tr;
        }

        console.log(table);
        return table;
      } else {
        return '<tr><td style="border: 1px solid black; padding: 10px;" colspan="5">No transactions recorded</td></tr>';
      }
    },
  },
  mounted: function () {
    console.log("StripeTransaction");
  },
  methods: {
    captureImmediatePayment: async function() {
      this.loadingCapture = true;

      console.log("Capturing Payment");

       try {
        let response = await axios.post(
          `${this.$store.state.apiUrl}/booking/capturePayment/${this.bookingForm.booking.id}`,
          {},
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }
        );

        this.loadingCapture = false;

        if (response.data.error == "no_error") {
          this.bookingForm.booking.card_status = 'completed';
        } else {
          alert(response.data.error);
        }
      } catch (error) {
        console.log(error);
        this.refundError = "Unknown Error";

        this.loadingCapture = false;
      }
    },
    getPaymentIntentStatusColor (status) {
      if (status == 'succeeded') {
        return 'green lighten-3'
      }
      if (status == 'canceled') {
        return 'red lighten-3'
      }
      return 'grey lighten-3'
    },
    formatDate(date) {
      return moment.unix(date).format("DD-MM-YYYY HH:MM")
    },
    formatAmount(amount) {
      return (amount / 100).toFixed(2)
    },
    getTransactions: async function () {
      this.loading = true;
      try {
        var url = `${this.$store.state.apiUrl}/customer/getTransactions?id=${this.bookingForm.user.id}`;

        let response = await axios.get(url, {
          params: {},
        });

        if (response.data.error == null) {
          console.log(this.transactions);
          this.transactions = response.data.transactions;
        } else {
          alert(response.data.error);
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log("Failed to get customer " + error);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.v-timeline-item {
  padding-bottom: 8px !important;
}


.list-item-height {
  min-height: 20px !important;
  line-height: 20px;
  font-size: 11px !important;
  font-weight: 300;
}

.v-timeline {
  padding-top: 8px !important;
}
.v-list--dense .v-list-item .v-list-item__content, .v-list-item--dense .v-list-item__content {
  padding: 0px;
  font-size: 11px;
}

.v-list--dense .v-list-item .v-list-item__subtitle {
  font-size: 11px !important;
  font-weight: 450;
}
</style>

   
